<p>cell-content-editor works!</p>
